import React from "react";
import { Grid, CircularProgress, Alert } from "@mui/material";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import UsersTable from "../components/Tables/UsersTable";
import NewSignupsCard from "../components/Cards/NewSignups";
import TotalUsersCard from "../components/Cards/TotalUsersCard";
import UsersGraph from "../components/Graphs/UsersGraph";
import PageTitle from "../components/Layout/PageTitle";
import AddUserButton from "../components/Buttons/AddUserButton";
import TotalUsersThisYear from "../components/Graphs/TotalUsersThisYear";
import { useUsers } from "../hooks/useUsers";

function Users() {
  const { data: users, isLoading, error, isError } = useUsers();

  if (isLoading) {
    return (
      <Grid container spacing={1} justifyContent="center">
        <Grid item xs={12} textAlign="center">
          <CircularProgress />
        </Grid>
      </Grid>
    );
  }

  if (isError) {
    return (
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Alert severity="error">
            Failed to load users: {error?.message || "Unknown error"}
          </Alert>
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container spacing={1}>
      <PageTitle title="Users">
        <AddUserButton />
      </PageTitle>
      <Grid item xs={12} sm={12} md={6}>
        <UsersGraph dateLength={30} />
      </Grid>
      <Grid item xs={12} sm={12} md={6}>
        <TotalUsersThisYear />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6} xl={3}>
        <TotalUsersCard users={users} />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6} xl={3}>
        <NewSignupsCard users={users} length="today" />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6} xl={3}>
        <NewSignupsCard users={users} length="weekly" />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6} xl={3}>
        <NewSignupsCard users={users} length="monthly" />
      </Grid>
      <Grid item xs={12}>
        <UsersTable users={users} />
      </Grid>
    </Grid>
  );
}

export default withAuthenticationRequired(Users);
